<template>
  <div class="videoMore" v-infinite-scroll="getVideos" infinite-scroll-disabled="busy" infinite-scroll-distance="150" infinite-scroll-root>
    <CustomizeHeader :home="false" :goBack="true"  title="長片"></CustomizeHeader>
    <v-row class="py-1 ma-0">
      <v-col
        style="padding: 6px"
        cols="6" 
        sm="4" 
        md="3" 
        lg="2" 
        xl="2" 
        v-for="(item, i) in items"
        :key="i"
      >
        <v-card 
          class="product-item" 
          :to="`/product/${item.id}`"
          flat
          @mouseover="$func.startPlayVideo($refs, i, $HOST_URL + item.video_info[0].uuid_path)"
          @mouseleave="$func.stopPlayVideo($refs, i)"
        >
          <span class="free" v-if="item.price === 0">Free</span>
          <span class="unlocked" v-if="purchaseID.includes(item.id)">已解鎖</span>
          <video-player 
            v-once
            :ref="`video${i}`"
            v-touch-event="() => $router.push(`/product/${item.id}`)"
            :playsinline="true" 
            @canplay="$func.onPlayerCanplay($event, i)"
            :options="$func.videoOption({
              src: null,
              autoplay: false,
              muted: true,
              loop: true,
              controls: false,
              poster: $HOST_URL + item.video_info[0].preview_path
            })"></video-player>
          <div class="information">
            <v-avatar size="35" class="mr-2" @click.prevent="$router.push(`/seller/${item.seller_id}`)">
              <v-img :src="$HOST_URL + item.usericon"/>
            </v-avatar>
            <v-col class="pa-0 rightInfo">
              <div class="product-title text-ellipsis" :title="item.title">{{ item.title }}</div>
              <div class="d-flex align-center review">
                <v-icon>fa-thumbs-up</v-icon>
                <span>{{ mul(item.praise_rate, 100) }}%</span>
                <v-icon>fa-unlock</v-icon>
                <span>{{ item.unlocks }}</span>
              </div>
            </v-col>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CustomizeHeader from '@/components/CustomizeHeader'
export default {
  components: { CustomizeHeader },
  data() {
    return {
      busy: false,
      page: 1,
      items: []
    }
  },
  computed: {
    ...mapGetters('user', ['purchaseID'])
  },
  methods: {
    getVideos() {
      this.busy = true
      this.axios.post('/products/condition', {
        search : [
          {table: 'products', column: 'product_type', keyword: 'video'}
        ],
        page: this.page,
        size: 50,
        includeSeller: true,
        sort: {
          table: 'products',
          column: 'created_at',
          by: 'desc'
        },
      }).then(response => {
        this.items = this.items.concat(response.data.data)
        if(this.page != response.data.last_page) {
          this.page += 1  
          this.busy = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.videoMore {
  .product-item {
    display: block;
  }
}
</style>